import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  TrafficLightHistory,
  TrafficLightOrder,
  TrafficLightPieces,
  TrafficLightRow,
  TrafficLightTakeOff,
  TrafficLightTick,
  YarnAnalysisRow,
} from '../../../models';
import { TmsWebBaseEditService } from '../../base';

// The traffic-light planning board (Requirements/traffic-light-board.md). Ids are SALES ORDER ids: an order is
// changed by ticking its steps, never saved or deleted as a whole.
@Injectable({
  providedIn: 'root',
})
export class TrafficLightService extends TmsWebBaseEditService<TrafficLightRow, TrafficLightOrder> {
  // Fired after something changes on an order, so the parent re-reads it and the tabs follow.
  public refreshDetails = new Subject<void>();

  constructor() {
    super('TrafficLight', $localize`Traffic Light System`);
  }

  history(orderId: string): Observable<TrafficLightHistory[]> {
    return this.httpService.get<TrafficLightHistory[]>(`${this.apiUrl}/History/${orderId}`);
  }

  // The yarn the lines with pieces to weave would use, against free stock. A 400 carries the reason it cannot be
  // worked out.
  yarnAnalysis(orderId: string): Observable<YarnAnalysisRow[]> {
    return this.httpService.get<YarnAnalysisRow[]>(`${this.apiUrl}/YarnAnalysis/${orderId}`);
  }

  // No line ids = every line the step applies to.
  tick(model: TrafficLightTick): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Tick`, model);
  }

  untick(model: TrafficLightTick): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/Untick`, model);
  }

  takeOff(model: TrafficLightTakeOff): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/TakeOff`, model);
  }

  putBack(orderId: string): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/PutBack/${orderId}`, {});
  }

  savePieces(model: TrafficLightPieces): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/SavePieces`, model);
  }

  // The step that creates the production order. Returns the production order number.
  createProductionOrder(orderId: string): Observable<number> {
    return this.httpService.post<number>(`${this.apiUrl}/Create/${orderId}`, {});
  }
}
